interface ISEVENTH_PAY_COMMISSION_FORMULA {
  basicPay: number;
  hraPercentageA: number;
  gradePay: number;
  payLevel?: string;
}
const PAY_LEVEL_TO_BASIC_PAY: Record<string, number> = {
  'Level 1': 18000,
  'Level 2': 19900,
  'Level 3': 21700,
  'Level 4': 25500,
  'Level 5': 29200,
  'Level 6': 35400,
  'Level 7': 44900,
  'Level 8': 47600,
  'Level 9': 53100,
  'Level 10': 56100,
  'Level 11': 67700,
  'Level 12': 78800,
  'Level 13': 123100,
  'Level 13A': 131100,
  'Level 14': 144200,
  'Level 15': 182200,
  'Level 16': 205400,
  'Level 17': 225000,
};
export const SEVENTH_PAY_COMMISSION_FORMULA = ({
  basicPay,
  hraPercentageA,
  payLevel,
}: ISEVENTH_PAY_COMMISSION_FORMULA) => {
  const payLevelBasicPay = payLevel
    ? PAY_LEVEL_TO_BASIC_PAY[payLevel]
    : undefined;
  const BasicPay = payLevelBasicPay !== undefined ? payLevelBasicPay : basicPay;

  const daPercentage = 55;
  const daAmount = (BasicPay * daPercentage) / 100;
  const hraAmount = (BasicPay * hraPercentageA) / 100;
  const grossSalary = BasicPay + daAmount + hraAmount;

  return {
    netSalary: Math.round(grossSalary),
    expectedDA: Math.round(daAmount),
    hraAmount: Math.round(hraAmount),
  };
};
